import { APIClient } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { CheckoutBasket } from '@frontend/basket/types';

export class BasketCheckoutClient extends APIClient {
    public static readonly endpoint = '/basket-api/v1';

    public static async checkoutBasket(accountId: string, basketId: string, body?: CheckoutBasket, withToken?: Token): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}/checkout`, body, true, withToken);
        return await this.handleVoidResponse(response);
    }
}
